import { render, staticRenderFns } from "./ContentNav.vue?vue&type=template&id=8b88bbc0"
import script from "./ContentNav.vue?vue&type=script&lang=js"
export * from "./ContentNav.vue?vue&type=script&lang=js"
import style0 from "./ContentNav.vue?vue&type=style&index=0&id=8b88bbc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports